<template>
  <div id="app"  class="flyout">
    <mdb-navbar color="blue-gradient" dark position="top" scrolling :scrollingOffset="20">
      <mdb-navbar-brand to="/" waves style="font-weight: bolder;">
        <img src="./assets/logo.png" height="30" alt="">信之威
      </mdb-navbar-brand>
      <mdb-navbar-toggler>
        <mdb-navbar-nav right>
          <mdb-nav-item to="/" waves-fixed>首页</mdb-nav-item>
          <mdb-nav-item v-for="(page,index) in pages" :key="index+1" :to="page.path" waves-fixed>{{page.name}}</mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>
    <main :style="{marginTop: '55px'}" style="min-height:90vh">
      <router-view></router-view>
    </main>
    <mdb-footer color="blue-gradient" class="pt-4 mt-4 text-center">
      <mdb-container class="text-md-left">
        <mdb-row>
          <mdb-col sm="4" class="my-3">
            <h5 class="title">APP下载</h5>
            <img src="/images/code1.png" style="width:150px;height:150px"></img>
          </mdb-col>
          <mdb-col sm="4" class="my-3">
            <h5 class="title">微信小程序</h5>
            <img src="/images/code2.png" style="width:150px;height:150px"></img>
          </mdb-col>
          <mdb-col sm="4" class="my-3">
            <h5 class="title">联系我们</h5>
              <p class="list-unstyled" v-if="email!==''">Email：{{email}}</p>
              <p class="list-unstyled" v-if="phone!==''">联系电话：{{phone}}</p>
              <p class="list-unstyled" v-if="qq!==''">微信：{{qq}}</p>
              <p class="list-unstyled"  v-if="address!==''">地址：{{address}}</p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
      <hr>
      <div class="call-to-action text-center">
        <h4 class="my-4"><strong>信之威</strong></h4>
        <h5>基于物联网的智能商砼解决方案</h5>
      </div>
      <div class="footer-copyright text-center py-3">
        <mdb-container fluid>
          <a href="http://www.beian.miit.gov.cn/">{{footer}}</a>
        </mdb-container>
      </div>
    </mdb-footer>
  </div>
</template>
<script>
import { mdbView,mdbContainer,mdbNavbar, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, mdbNavbarBrand, mdbFooter,mdbRow,mdbCol } from 'mdbvue';
export default {
  name:'app',
  components:{
    mdbNavbar,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbNavbarBrand,
    mdbFooter,
    mdbCol,
    mdbRow,
    mdbContainer,
    mdbView
  },
  data:()=>({
    address:"",
    phone:"",
    qq:"",
    email:"",
    footer:"",
    pages:[]
  }),
  methods:{
    initData(){
      this.$axios.get('/config/config.json').then(function(response){
        document.title=response.data.title;
        this.address=response.data.address;
        this.phone=response.data.phone;
        this.email=response.data.email;
        this.qq=response.data.qq;
        this.footer=response.data.footer;
        this.pages=[];
        response.data.pages.forEach(e=>{
          let page={}
          page.path=response.data[e].path;
          page.name=response.data[e].name;
          this.pages.push(page);
        })
      }.bind(this))
    }
  },
  created(){
    this.initData();
  }
}
</script>